import type { ActionTemplateParameterResource, ControlType } from "@octopusdeploy/octopus-server-client";
import { bindParameterName, unbindParameterName } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { controlTypeValueToTextMap } from "~/components/ControlType/ControlTypeSelector";
import { SelectWithActions } from "~/components/form/SelectWithActions/SelectWithActions";
interface ParameterOption {
    value: string;
    text: string;
}
interface BaseParameterSelectorProps {
    selectedParameter: string | null | undefined;
    onParameterChange(value: string | null): void;
    controlType: ControlType;
    allowClear: boolean;
    error?: string | undefined;
    label?: string;
    parameters: ActionTemplateParameterResource[] | undefined;
    bindValue?: boolean;
    actions?: React.ReactElement[];
}
export function BaseParameterSelector({ allowClear, controlType, error, label, onParameterChange, selectedParameter, parameters, bindValue = true, actions }: BaseParameterSelectorProps) {
    const parameterOptions: ParameterOption[] = parameters
        ?.filter((p) => p.DisplaySettings["Octopus.ControlType"] === controlType)
        ?.map((p: ActionTemplateParameterResource) => ({
        value: p.Name,
        text: p.Label || p.Name,
    })) || [];
    const unboundSelectedParameter = bindValue ? unbindParameterName(selectedParameter) : selectedParameter;
    const isSelectedParameterInvalid = unboundSelectedParameter ? parameterOptions.every((option) => option.value !== unboundSelectedParameter) : false;
    const missingParameterError = isSelectedParameterInvalid ? `Selected parameter '${unboundSelectedParameter}' can't be found` : undefined;
    const controlTypeText = controlTypeValueToTextMap.get(controlType);
    const displayLabel = label || `${controlTypeText} parameter`;
    const emptyMessage = parameterOptions?.length === 0 ? `No ${controlTypeText?.toLowerCase()} parameters found` : undefined;
    return (<SelectWithActions value={unboundSelectedParameter || undefined} onChange={(value) => {
            const newValue = bindValue && value ? bindParameterName(value) : value || null;
            onParameterChange(newValue);
        }} items={parameterOptions} label={displayLabel} empty={emptyMessage} allowClear={allowClear} allowFilter={true} error={error || missingParameterError} actions={actions || []}/>);
}
